function openTidio() {
  window.tidioChatApi.show()
  window.tidioChatApi.open()
}

var OpenTidio = openTidio

export default OpenTidio